(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminPerformanceDisplaySettingsController', AdminPerformanceDisplaySettingsController);

    function AdminPerformanceDisplaySettingsController(
        $controller,
        lodash,
        settingsCollection,
        recurrenceRulesService,
        elbSettings,
        $state,
        module,
        modulesService
    ) {
        const vm = this;
        vm.patrolsEnabled = modulesService.isEnabled('patrols_module');
        vm.surveysEnabled = modulesService.isEnabled('surveys_module');
        vm.quotesModuleEnabled = modulesService.isEnabled('quotes');
        
        const base = $controller('AdminDisplaySettingsController', {
            lodash: lodash,
            settingsCollection: settingsCollection,
            settingsFields: [
                'performance_system_score_weight',
                ...(vm.quotesModuleEnabled ? ['performance_quote_score_weight'] : []),
                ...(vm.surveysEnabled ? ['performance_include_survey_score', 'performance_survey_score_weight'] : []),
                // Patrol-related settings are only available when Patrols module is enabled
                ...(vm.patrolsEnabled ? ['performance_include_patrol_score', 'performance_patrol_score_weight'] : [])
            ],
            recurrenceRulesService: recurrenceRulesService,
            elbSettings: elbSettings,
            $state: $state,
            module: module,
            modulesService: modulesService
        });

        angular.extend(vm, base);
    }
})();
